import {ValueObject} from '@s-ui/domain'

export default class NewsPaginationValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {String} deps.previous
   * @param {String} deps.next
   */
  constructor({previous, next}) {
    super({previous, next})
  }
}
